import { Outlet, Link } from 'react-router-dom';
import { ShieldCheck } from 'lucide-react';
import { Separator } from '@/components/ui/separator';

/**
 * Admin console layout — provides a consistent header matching the
 * ModuleHeader pattern used by dynamic modules. Child routes render
 * via the Outlet below the header.
 */
export default function AdminLayout() {
  return (
    <>
      <div className="mb-4">
        <Link to="/admin" className="flex items-center gap-3 px-1 py-2 hover:opacity-80 transition-opacity">
          <ShieldCheck className="h-5 w-5 shrink-0 text-primary" aria-hidden="true" />
          <h1 className="text-lg font-semibold leading-tight">Admin Console</h1>
        </Link>
        <Separator />
      </div>
      <Outlet />
    </>
  );
}
